import React from 'react'

import DeleteAccountModal from './DeleteAccountModal'
import ChangePasswordModal from './ChangePasswordModal'
import SupportModal from 'components/modals/SupportModal'
import UploadAvatarModal from './UploadAvatarModal'
import EditSocialMediaModal from './EditSocialMediaModal'
import EditShippingAddressModal from './EditShippingAddressModal'
import DeclineInviteModal from './DeclineInviteModal'
import LeaveModal from './LeaveModal'
import MediaPreviewModal from './MediaPreviewModal'
import StatusInfoModal from './StatusInfoModal'
import { SupportSuccessModal } from 'components/SupportDrawer'
import InterestFormSuccess from './InterestFormSuccess'
import SubmissionFormSuccess from './SubmissionFormSuccess'
import WelcomeModal from './WelcomeModal'

const InitModals = () => {
  return (
    <>
      <SupportModal />
      <UploadAvatarModal />
      <DeleteAccountModal />
      <ChangePasswordModal />
      <EditSocialMediaModal />
      <EditShippingAddressModal />
      <DeclineInviteModal />
      <LeaveModal />
      <MediaPreviewModal />
      <SupportSuccessModal />
      <StatusInfoModal />
      <InterestFormSuccess />
      <SubmissionFormSuccess />
      <WelcomeModal />
    </>
  )
}

export default InitModals
